import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { DARK, isLiquorice, isLollipop } from '@bubble-ui/particle-design-versions';
export var getDefaultStyleSheet = function getDefaultStyleSheet(_ref) {
  var color = _ref.color,
    date = _ref.date,
    direction = _ref.direction,
    designContext = _ref.designContext,
    designVersion = _ref.designVersion,
    isStacked = _ref.isStacked,
    maxWidth = _ref.maxWidth,
    shouldTruncateText = _ref.shouldTruncateText,
    status = _ref.status;
  var backgroundColor = designVersion === DARK && color === 'black' ? designContext.get('colors/backgrounds/default').toString() : designContext.get('chat-bubble/background-color', {
    color: color
  }).toString();
  var borderColor = designVersion === DARK && color === 'black' ? designContext.get('colors/borders/subtle-floating').toString() : designContext.get('chat-bubble/border-color', {
    color: color
  }).toString();
  var textColor = designVersion === DARK && color === 'black' ? designContext.get('colors/text/default').toString() : designContext.get('chat-bubble/text-color', {
    color: color
  }).toString();
  var textStyle = designContext.get('chat-bubble/text-style', {
    status: status
  }).styles();
  var timestampDateTextColor = designContext.get('chat-bubble/timestamp-date-text-color').toString();
  var timestampDateTextStyle = designContext.get('chat-bubble/timestamp-date-text-style').styles();
  var timestampTimeTextStyle = designContext.get('chat-bubble/timestamp-time-text-style').styles();
  var cornerRadius = designContext.get('chat-bubble/corner-radius').pixelValue;
  var borderRadius = isLiquorice(designVersion) || isLollipop(designVersion) ? 25 : cornerRadius;
  return {
    mainStyle: {
      alignItems: direction === 'left' ? 'flex-start' : 'flex-end',
      maxWidth: maxWidth,
      position: 'relative'
    },
    backgroundStyle: {
      backgroundColor: backgroundColor,
      borderColor: borderColor,
      borderWidth: 1,
      borderBottomLeftRadius: direction === 'left' ? isStacked ? 0 : borderRadius : direction === 'right' ? borderRadius : undefined,
      borderBottomRightRadius: direction === 'right' ? isStacked ? 0 : borderRadius : direction === 'left' ? borderRadius : undefined,
      borderTopLeftRadius: direction === 'left' ? 0 : borderRadius,
      borderTopRightRadius: direction === 'right' ? 0 : borderRadius,
      padding: 14
    },
    paragraphSecondaryCorrectFootprintBlockStyle: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      color: textColor
    }, textStyle), isLiquorice(designVersion) ? {
      lineHeight: 21
    } : {}), {}, {
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left'
    }, shouldTruncateText && {
      maxWidth: maxWidth,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }), {}, {
      wordBreak: 'break-word',
      marginBottom: -8,
      marginTop: -5,
      paddingBottom: 2,
      paddingTop: 0
    }),
    paragraphQuaternaryCorrectFootprintDarkGrayStyle: _objectSpread(_objectSpread({
      color: timestampDateTextColor
    }, timestampTimeTextStyle), {}, {
      textRendering: 'geometricPrecision',
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left',
      wordBreak: 'break-word',
      marginBottom: 0,
      marginTop: 0
    }),
    timestampStyle: {
      flexDirection: 'row',
      paddingTop: 10
    },
    timestampMainStyle: {
      flexDirection: 'row',
      position: 'relative'
    },
    timestampDateViewStyle: {},
    timestampDateTextStyle: _objectSpread(_objectSpread(_objectSpread({
      color: timestampDateTextColor
    }, timestampDateTextStyle), isLiquorice(designVersion) ? {
      lineHeight: 13,
      fontWeight: '500'
    } : {}), {}, {
      textRendering: 'geometricPrecision',
      WebkitFontSmoothing: 'antialiased',
      marginBottom: 0,
      marginTop: 0
    }),
    timestampTimeStyle: {
      paddingLeft: date ? 3 : 0
    },
    timestampCheckmarkStyle: {
      marginTop: -4,
      marginBottom: -4,
      marginRight: direction === 'right' ? -4 : 0
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map